// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {
	// Write your JavaScript here
	//$w("#lightbox1").

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});


export function onChangeGettingMoreExpensive(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	if($w("#text88").hidden){
		$w("#text88").show();
	} else {
		$w("#text88").hide();
	}
}

export function onChangeTama38(event) {
	if(event.target.value === "no_tama"){
		$w("#input77").hide();
		$w("#text99").hide();
		$w("#input78").hide();
	} else{
		$w("#input77").show();
		$w("#input78").show();
		if($w("#dropdown11").value === 'yes_tama_rise_price') {
			$w("#text99").show();
		}
	}
}

export function onRiseTamaPrice(event) {
	if(event.target.value === 'yes_tama_rise_price') {
		$w("#text99").show();
	} else {
		$w("#text99").hide();
	}
}